<div class="position-relative">
  <ngx-spinner
    name="spEliminarMenu"
    bdColor="rgba(255,255,255,0.8)"
    size="default"
    color=" var(--primary-color)"
    type="ball-atom"
    [fullScreen]="false"
  >
  </ngx-spinner>

  <div>
    ¿Esta seguro que desea eliminar el registro
    {{ data.descripcion != "" || null ? data.descripcion : "" }}?
    <br />
    <br />
  </div>
  <div class="row">
    <div class="col">
      <button
        mat-raised-button
        color="primary"
        *appRoles="['Menus.Eliminar']"
        (click)="doAction()"
      >
        Eliminar
      </button>
    </div>
    <div class="col">
      <button mat-button (click)="closeDialog()" mat-flat-button color="warn">
        <span>Cancelar</span>
      </button>
    </div>
  </div>
</div>
